import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewRelatedDevices from './viewRelatedDevice';

export default {
  title: 'Data',
  parentId: 'appConfigId',
  isObjectWrapper: true,
  attributeName: 'configData',
  default: {
    minBuildNumber: 1
  },
  fields: [
    {
      attributeName: 'minBuildNumber',
      helpText: 'Build number',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'minBuildNumber',
      placeholder: 'minBuildNumber...',
    },
    // {
    //   attributeName: 'appFramework',
    //   helpText: 'App Framework',
    //   type: FormInputTypes.SELECT,
    //   label: 'App Framework',
    //   placeholder: 'appFramework...',
    //   multiple: true,
    //   options: [
    //     { name: '', value: '' },
    //     { name: 'native', value: 'native' },
    //     { name: 'unity', value: 'unity' },
    //   ],
    // },
    {
      attributeName: 'appEnviroment',
      helpText: 'App Platform',
      type: FormInputTypes.SELECT,
      label: 'App Platform',
      placeholder: 'platform...',
      multiple: true,
      options: [
        { name: '', value: '' },
        { name: 'App Android XR', value: 'app-androidxr'},
        { name: 'App iOS', value: 'app-ios'},
        { name: 'App Unity', value: 'app-unity'},  
        { name: 'App Unity Oculus', value: 'app-unity-oculus'},   
        { name: 'App Unity Android', value: 'app-unity-android'},   
        { name: 'App Unity Pico', value: 'app-unity-pico'},
        { name: 'App Vision', value: 'app-vision'},
        { name: 'App Web', value: 'app-web'},
        { name: 'Mobile Android', value: 'mobile-android'},
        { name: 'SDK Android', value: 'sdk-android'},
        { name: 'SDK Android XR', value: 'sdk-androidxr'},
        { name: 'SDK Apple', value: 'sdk-apple'},
        { name: 'SDK iOS', value: 'sdk-ios'},
        { name: 'SDK Unity', value: 'sdk-unity'},
        { name: 'SDK Vision', value: 'sdk-vision'}, 
        { name: 'SDK Web', value: 'sdk-web'}, 
      ],
    },
 {
      attributeName: 'devices',
      label: 'Devices',
      type: FormInputTypes.RELATIONSHIP,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      configFile: viewRelatedDevices,
      helpText: 'Select one or more registered devices. Device IDs will be stored automatically.',
    },
    {
      attributeName: 'deviceName',
      helpText: 'List of device Names',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Device Name',
      multiple:true,
      placeholder: 'Press enter to add Device Name...',
    },
    {
      attributeName: 'countryCode',
      helpText: 'List of Country Codes',
      type: FormInputTypes.SELECT,
      label: 'Country Code',
      placeholder: 'Please enter to add Country code...',
      multiple: true,
      url: 'countries',
      filter:'name',
      asyncSelect: true,
      options: [],
    },
    {
      attributeName: 'languageCode',
      helpText: 'List of Language Codes',
      type: FormInputTypes.SELECT,
      label: 'Language Code',
      options: [
        {name:"Spanish", value:"es"},
        {name:"English", value:"en"},
      ],
      emptyValue:true,
      default:'(Empty)', //default value to empty option
    },
    {
      attributeName: 'IP',
      helpText: 'List of IPs and Ranges in CIDR format. Remember to add the correct IP/RANGE format.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'IP',
      multiple:true,
      placeholder: 'Press enter to add IP in correct IP/RANGE... xx.xx.xx.xx/yy',
    },
    {
      attributeName: 'oculusUser',
      helpText: 'List of Oculus Users',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Oculus User',
      multiple:true,
      placeholder: 'Press enter to add Oculus User...',
    },
    {
      attributeName: 'comment',
      helpText: 'Comment to identify this group od config data',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Comment',
      placeholder: 'Press enter to add Comment...',
    },
  ],
};
